<div class="dialog-content">
  <h1 mat-dialog-title>{{dialogTitle}}</h1>
  <mat-divider></mat-divider>
  <form class="example-form" [formGroup]="productEditForm" (ngSubmit)="onOk()">
    <div class="row">
      <div class="col mt-2">
        <div>
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Name</mat-label>
            <input matInput [(ngModel)]="this.product.name" name="name" formControlName="name">
          </mat-form-field>
        </div>
        <div>
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>UUID</mat-label>
            <input matInput type="text" [(ngModel)]="this.product.productUID" name="uid" formControlName="uid">
          </mat-form-field>
        </div>
        <div>
          <mat-form-field appearance="outline" style="width: 30%">
            <mat-label>Code</mat-label>
            <input matInput type="number" [(ngModel)]="this.product.code" name="code" formControlName="code">
          </mat-form-field>
          <mat-form-field appearance="outline" style="width: 30%">
            <mat-label>Account Type</mat-label>
            <mat-select [(ngModel)]="this.product.accountType" name="accountType" formControlName="accountType">
              <mat-option>-- Select --</mat-option>
              <mat-option value="deposit">Deposit</mat-option>
              <mat-option value="savings">Savings</mat-option>
              <mat-option value="time">Time</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline" style="width: 30%">
            <mat-label>Product Type</mat-label>
            <mat-select [(ngModel)]="this.product.productType" name="productType" formControlName="productType">
              <mat-option>-- Select --</mat-option>
              <mat-option value="DDA">DDA</mat-option>
              <mat-option value="SAV">SAV</mat-option>
              <mat-option value="MMA">MMA</mat-option>
              <mat-option value="COD">COD</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div>
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Info URL</mat-label>
            <input matInput type="text" [(ngModel)]="this.product.infoUrl" name="infoUrl" formControlName="infoUrl">
          </mat-form-field>
        </div>
        <div>
        </div>
        <div>
          <mat-form-field appearance="outline" style="width: 90px">
            <mat-label>Q2 Group ID</mat-label>
            <input matInput type="number" [(ngModel)]="this.product.olbGroupId" name="olbGroupId"
                   formControlName="olbGroupId">
          </mat-form-field>
          <mat-form-field appearance="outline" style="width: 130px">
            <mat-label>Alloy Workflow</mat-label>
            <input matInput type="number" [(ngModel)]="this.product.alloyWorkflowId" name="alloyWorkflowId"
                   formControlName="alloyWorkflowId">
          </mat-form-field>
        </div>
        <div>
          <mat-form-field appearance="outline" style="width: 130px">
            <mat-label>Interest Plans</mat-label>
            <input matInput type="text" [(ngModel)]="this.interestPlanCodesString" name="interestPlanCodes"
                   formControlName="interestPlanCodes">
          </mat-form-field>

          <mat-form-field appearance="outline" style="width: 130px">
            <mat-label>Account Limit</mat-label>
            <input matInput type="number" [(ngModel)]="this.product.maxNumberOfAccounts" name="maxNumberOfAccounts"
                   formControlName="maxNumberOfAccounts">
          </mat-form-field>
        </div>
        <div>
          <mat-form-field floatLabel="always">
            <mat-label>Joint Accounts?</mat-label>
            <mat-slide-toggle [(ngModel)]="this.product.allowJointApplications"
                              formControlName="allowJointApplications">
              <span class="text-invisible">Joint Accounts?</span>
            </mat-slide-toggle>
            <textarea matInput hidden></textarea>
          </mat-form-field>
          <mat-form-field floatLabel="always">
            <mat-label>Enabled?</mat-label>
            <mat-slide-toggle [(ngModel)]="this.product.isActive" formControlName="isActive">
              <span class="text-invisible">Enabled?</span>
            </mat-slide-toggle>
            <textarea matInput hidden></textarea>
          </mat-form-field>
        </div>
        <div>
          <mat-form-field floatLabel="always">
            <mat-label>Allow Multi Product?</mat-label>
            <mat-slide-toggle [(ngModel)]="this.product.allowMultiProductApplications" formControlName="allowMultiProductApplications">
              <span class="text-invisible">Allow Multi Product?</span>
            </mat-slide-toggle>
            <textarea matInput hidden></textarea>
          </mat-form-field>
        </div>
        <div *ngIf="this.product.productType === 'DDA'">
          <mat-form-field floatLabel="always">
            <mat-label>Free Debit Card?</mat-label>
            <mat-slide-toggle [(ngModel)]="this.product.freeDebitCard" formControlName="freeDebitCard">
            </mat-slide-toggle>
            <textarea matInput hidden></textarea>
          </mat-form-field>
          <mat-form-field floatLabel="always">
            <mat-label>Free Standard Check?</mat-label>
            <mat-slide-toggle [(ngModel)]="this.product.freeStandardCheck" formControlName="freeStandardCheck">
            </mat-slide-toggle>
            <textarea matInput hidden></textarea>
          </mat-form-field>
        </div>
      </div>
      <div class="col mt-2 descriptors">
        <div>
          <div class="clearfix">
            <h2 class="float-left">Descriptors</h2>
            <button type="button" class="float-right" mat-button
                    (click)="toggleAddDescriptor()"
                    [textContent]="!activateAddDescriptor ? 'Add New' : ''"
            >
              <!--                     *ngIf="allowGlobalSettingCreate">-->
            </button>
          </div>
          <div class="clearfix mt-2">
            <form [formGroup]="addDescriptorForm" *ngIf="activateAddDescriptor">
              <mat-form-field appearance="outline" class="descriptor-entry">
                <mat-label>New descriptor</mat-label>
                <input matInput name="descriptor" formControlName="descriptor">
              </mat-form-field>
              <button type="button" mat-icon-button [disabled]="!addDescriptorForm.valid"
                      (click)="onSaveNewDescriptor()">
                <mat-icon>check</mat-icon>
              </button>
              <button type="button" (click)="onCancelAddDescriptor()" mat-icon-button>
                <mat-icon>close</mat-icon>
              </button>
            </form>
            <form [formGroup]="editDescriptorForm" *ngIf="activateEditDescriptor">
              <mat-form-field appearance="outline" class="descriptor-entry">
                <mat-label>Edit descriptor</mat-label>
                <input matInput name="descriptor" formControlName="descriptor">
              </mat-form-field>
              <button type="button" mat-icon-button [disabled]="!editDescriptorForm.valid"
                      (click)="onModifyDescriptor()">
                <mat-icon>check</mat-icon>
              </button>
              <button type="button" (click)="onCancelModifyDescriptor()" mat-icon-button>
                <mat-icon>close</mat-icon>
              </button>
            </form>
          </div>
          <div class="clearfix">
            <span *ngIf="descriptorList.data.length === 0">
              No descriptors created.
              <button mat-button type="button" class="link-button"
                      (click)="toggleAddDescriptor()">Click to add one.</button>
            </span>
            <table mat-table [dataSource]="descriptorList"
                   *ngIf="descriptorList.data.length > 0" class="full-width">

              <!--- Note that these columns can be defined in any order.
                    The actual rendered columns are set as a property on the row definition" -->

              <!-- Position Column -->
              <ng-container matColumnDef="descriptor">
                <td mat-cell style="width: 300px" *matCellDef="let element">
                  {{element.descriptor}}
                </td>
              </ng-container>

              <ng-container matColumnDef="edit">
                <td mat-cell *matCellDef="let element">
                  <button type="button" mat-icon-button
                          (click)="activateModifyDescriptor(element.id, element.descriptor)">
                    <mat-icon>edit</mat-icon>
                  </button>
                </td>
              </ng-container>

              <ng-container matColumnDef="delete">
                <td mat-cell *matCellDef="let element" (click)="onDeleteDescriptor(element.id)">
                  <button type="button" mat-icon-button>
                    <mat-icon>delete_outline</mat-icon>
                  </button>
                </td>
              </ng-container>

              <tr mat-row *matRowDef="let row; columns: displayedColumns;" [class.new-row]='row.isNew'></tr>
            </table>
          </div>
        </div>
        <div class="note">Creates, updates, and deletes are not committed until clicking <strong>Save</strong>.</div>
      </div>
    </div>
  </form>
  <mat-divider></mat-divider>
  <mat-dialog-actions>
    <button mat-button type="submit" [disabled]="!productEditForm.valid" (click)="onOk()"
            [mat-dialog-close]="data.product">{{buttonText}}
    </button>
    <button type="button" mat-button mat-dialog-close>Cancel</button>
  </mat-dialog-actions>
</div>
